import { PermissionKey_FE } from '@nu-art/permissions-frontend/PermissionKey_FE';
import { AdvisorUIManagerPermissionKeys } from '@app/advisor-ui-shared';
export const permissions_AdvisorUIManager = PermissionKey_FE.generatePermissionKeysByLevels(AdvisorUIManagerPermissionKeys);
//# sourceMappingURL=advisor-ui-manager.js.map